import React, { Component } from 'react';

class PopupNotas extends Component {
    state = {  }
    render() { 
        var unidade = this.props.unidade === undefined ? '%': this.props.unidade;
        return ( <div style={{minWidth:"200px"}}>
            <div className="edb-xlarge">{this.props.titulo}</div>
            <div className="edb-right-align">
                {!this.props.grade && <div className="edb-margin-small-top">
                    Meu desempenho: 
                    <div className="edb-large edb-text-bold edb-inline edb-margin-small-left">{this.props.meuDesempenho || 0}{unidade}</div>
                    &nbsp;
                    { ((this.props.meuDesempenho || 0) < (this.props.minhaEscola || 0)) &&  <i className="edb-large fas fa-exclamation-triangle adap-text-red"></i> }
                </div>}
                {!this.props.grade && <div className="">
                    Minha escola: 
                    <div className="edb-large edb-text-bold edb-inline edb-margin-small-left">{this.props.minhaEscola || 0}{unidade}</div>
                    &nbsp;
                    <span style={{display:"inline-block", marginLeft:'8px', marginRight:'8px', width:'4px', height:"18px", backgroundColor: "#666"}}></span>
                </div>}
                {this.props.grade && <div className="edb-margin-small-top">
                    Desempenho da série: 
                    <div className="edb-large edb-text-bold edb-inline edb-margin-small-left">{this.props.meuDesempenho || 0}{unidade}</div>
                </div>}
                {false && <div>
                    Escola de referência:  
                    <div className="edb-large edb-text-bold edb-inline edb-margin-small-left">{this.props.escolaReferencia || 0}{unidade}</div>
                    &nbsp;
                    <i className="edb-large fas fa-star adap-text-yellow "></i>
                </div>}
            </div>
        </div> );
    }
}
 
export default PopupNotas;